export default "__VITE_ASSET___JduUQ9G__"